module.exports = __webpack_public_path__ + "img/ics_f_copy.1e718c39.svg";